import PropTypes from 'prop-types';
import { ACTIONS } from '../Calculator';
import './style.css';

export const ButtonEvaluate = ({ dispatch, simbol }) => {
  return (
    <button
      onClick={() => dispatch({ type: ACTIONS.EVALUATE })}
      className="buttonEvaluate"
    >
      {simbol}
    </button>
  );
};

ButtonEvaluate.propTypes = {
  dispatch: PropTypes.func,
  simbol: PropTypes.string,
};
